module.exports = __webpack_public_path__ + "static/media/octagonshape.895c9d5a.jpg";